/**
 * Service for position enable/disable operations
 */

import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';


export class PositionEnableDisableService {
  async enable(positionId: number): Promise<ApiResponse<null>> {
    const endpoint = API_CONFIG.ENDPOINTS.ORGANIZATION.ENABLE_POSITION(positionId);

    return await apiClient.patch<null>(endpoint, {});
  }

  async disable(positionId: number): Promise<ApiResponse<null>> {
    const endpoint = API_CONFIG.ENDPOINTS.ORGANIZATION.DISABLE_POSITION(positionId);

    return await apiClient.patch<null>(endpoint, {});
  }
}

export const positionEnableDisable = new PositionEnableDisableService();
